module.exports = __webpack_public_path__ + "static/media/slide-1.c328c30f.jpg";